import { configureStore } from '@reduxjs/toolkit'
import partnerReducer from '../features/partners/partnerReducer'
// import partnersReducer from '../features/partners/partnerSlice'

export const store = configureStore({
    reducer: {
        partners: partnerReducer
        // partners: partnersReducer
    }
})